import { createSqliteDatabaseAdapterAdapter, } from '@dossierhq/sqlite-core';
export async function createSqlJsAdapter(context, database, options) {
    const adapter = {
        disconnect: () => {
            database.close();
            return Promise.resolve();
        },
        createTransaction() {
            return null;
        },
        query: (_context, query, values) => {
            const result = [];
            const statement = database.prepare(query, values);
            while (statement.step()) {
                const row = statement.getAsObject();
                result.push(row);
            }
            statement.free();
            return Promise.resolve(result);
        },
        run: (_context, query, values) => {
            database.run(query, values);
            return Promise.resolve(database.getRowsModified());
        },
        isFtsVirtualTableConstraintFailed,
        isUniqueViolationOfConstraint,
        encodeCursor(value) {
            return btoa(unescape(encodeURIComponent(value)));
        },
        decodeCursor(value) {
            return decodeURIComponent(escape(atob(value)));
        },
        randomUUID: () => crypto.randomUUID(),
    };
    return createSqliteDatabaseAdapterAdapter(context, adapter, options);
}
function isFtsVirtualTableConstraintFailed(error) {
    return error instanceof Error && error.message === 'constraint failed';
}
function isUniqueViolationOfConstraint(error, constraint) {
    if (error instanceof Error) {
        const qualifiedColumns = constraint.columns.map((column) => `${constraint.table}.${column}`);
        const expectedMessage = `UNIQUE constraint failed: ${qualifiedColumns.join(', ')}`;
        return error.message === expectedMessage;
    }
    return false;
}
//# sourceMappingURL=SqlJsAdapter.js.map